import { useAuthorizedLabel, useLocale } from '@gov-nx/core/service';
import {
	PageCode,
	useProfilROSReklamaceContextInstance,
} from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';

export const ProfileROSComplaintSubmitButton = ({
	onClick,
}: {
	onClick: () => void;
}) => {
	const { t } = useLocale(PageCode['profil-ROS']);
	const authLabel = useAuthorizedLabel();

	const { controls, disableSubmitButton, isAuthorizationEnforced } =
		useProfilROSReklamaceContextInstance();

	const isProcessing = controls.processLoading;

	return (
		<Button
			isLoading={isProcessing}
			isDisabled={isProcessing || disableSubmitButton}
			onClick={onClick}
			color="primary"
			size="m"
			type="solid"
			isExpandedMobile>
			{authLabel(t('akce.odeslat-reklamaci'), isAuthorizationEnforced)}
		</Button>
	);
};
